import { useParams, useLocation } from 'react-router-dom';

// The canonical public use-case page lives on the landing app (SSR, working OG
// previews). Mirror ReviewRedirect: bounce to clareefai.com, forwarding the
// query string so `?slug=` reaches the page and its OG image.
export default function PublicUseCaseRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const target = `https://clareefai.com/use-case/${id ?? ''}${search}`;
  window.location.replace(target);
  return null;
}
